import { render } from "./NewHospital.vue?vue&type=template&id=07c8749a"
import script from "./NewHospital.vue?vue&type=script&lang=js"
export * from "./NewHospital.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/hospitals/NewHospital.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "07c8749a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('07c8749a', __exports__)) {
    console.log('reload')
    api.reload('07c8749a', __exports__)
  }
  
  module.hot.accept("./NewHospital.vue?vue&type=template&id=07c8749a", () => {
    console.log('re-render')
    api.rerender('07c8749a', render)
  })

}


export default __exports__